import { useEffect, useState } from "react";
import SecondaryButton from "../../../ui/SecondaryButton";
import SquareBarChart from "../ClubFinancial/SquareBarchart";
import TransferHistory from "../ClubFinancial/TransferHistory";
import SquadPlayers from "./SquadPlayers";
import DrawerComponent from "../../../ui/Drawer";
import FullViewTransferHistory from "../ClubFinancial/FullViewTranferHistory";
import styled from "styled-components";

const MarketValueContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  .secondary-cta-text {
    padding-right: 0px;
  }
`;
interface SquadTabPropTypes {
  teamId: string;
  clubName?: string | undefined;
}

export const SquadTab: React.FC<SquadTabPropTypes> = ({
  teamId,
  clubName,
}) => {

  const [isFullViewOpen, setIsFullViewOpen] = useState<boolean>(false);

  return (
    <div style={{paddingTop:'38px'}}>

        
      <SquareBarChart teamId={Number(teamId)} />
      <SquadPlayers teamId={teamId} />
      <TransferHistory teamId={teamId} isFullView={isFullViewOpen} />
      <div className="expanded-view-btn" style={{ justifySelf: "center" }}>
        <SecondaryButton
          iconType="expandedview"
          label="Show full transfer history"
          onClick={() => {
            setIsFullViewOpen(true);
          }}
        />
      </div>
      {isFullViewOpen && (
        <DrawerComponent
          open={isFullViewOpen}
          onClose={() => {
            setIsFullViewOpen(false);
          }}
          styleVariant="value-graph"
          customClassName="career-drawer-main career-drawer"
        >
          <FullViewTransferHistory
            teamId={teamId}
            onClose={() => {
              setIsFullViewOpen(false);
            }}
            isFullView={isFullViewOpen}
            clubName={clubName}
          />
        </DrawerComponent>
      )}
    </div>
  );
};
